import React, { useEffect } from "react";
import { Text } from "../../components/Text";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const GoogleCallback: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const error = params.get("error");

    if (error) {
      window.close();
      return;
    }

    if (!code) {
      navigate("/");
    }

    if (code && window.opener) {
      window.opener.postMessage(
        { type: "GOOGLE_LOGIN_SUCCESS", code },
        window.location.origin,
      );
      window.close();
    }
  }, [navigate]);

  return <Text>{t("common.authenticating")}</Text>;
};
